<app-header
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<div class="page-content" (click)="closeMegaMenuCondition()">
    <img src="assets/images/icons/404-icon.svg" alt="404 Icon" class="icon" />
    <span class="title">
        {{ "NOT_FOUND.TITLE" | translate }}
    </span>
    <span class="description">
        {{ "NOT_FOUND.DESCRIPTION" | translate }}
    </span>
    <button class="button-home" (click)="onNavHome()">
        {{ "NOT_FOUND.CTA" | translate }}
    </button>
</div>
<app-footer
    (click)="closeMegaMenuCondition()"
    [selectedLanguage]="languageSelected"
></app-footer>
